import { render } from "./TokenList.vue?vue&type=template&id=aeec82b2&scoped=true"
import script from "./TokenList.vue?vue&type=script&lang=js"
export * from "./TokenList.vue?vue&type=script&lang=js"

import "./TokenList.vue?vue&type=style&index=0&id=aeec82b2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeec82b2"]])

export default __exports__